(function () {
  function getScopeFromTabList(tabList) {
    return (
      tabList.closest(".tab-grand") ||
      tabList.closest(".tabs") ||
      tabList.closest(".section-tabbed-content") ||
      tabList.closest("section") ||
      tabList.parentElement ||
      document
    );
  }

  function setSelectedTab(scope, targetTab) {
    if (!scope || !targetTab) return;

    const tabId = targetTab.getAttribute("aria-controls");
    if (!tabId) return;

    // Unselect tabs within this scope
    scope.querySelectorAll('.tab-button[aria-selected="true"]').forEach((t) => {
      t.setAttribute("aria-selected", "false");
      t.setAttribute("tabindex", "-1");
    });

    // Select clicked tab
    targetTab.setAttribute("aria-selected", "true");
    targetTab.setAttribute("tabindex", "0");

    // Hide panels within this scope
    scope.querySelectorAll(".tab-content").forEach((p) => {
      p.setAttribute("hidden", "true");
    });

    // Show selected panel
    const selectedPanel = scope.querySelector(`#${CSS.escape(tabId)}`);
    if (selectedPanel) selectedPanel.removeAttribute("hidden");
  }

  function initTabMenu(tabList) {
    if (!tabList) return;

    // Prevent double-binding
    if (tabList.dataset.tabsInitialized === "true") return;
    tabList.dataset.tabsInitialized = "true";

    const scope = getScopeFromTabList(tabList);
    const tabs = Array.from(tabList.querySelectorAll(".tab-button"));
    if (!tabs.length) return;

    // Ensure only one tab starts selected
    const selectedTabs = tabs.filter((t) => t.getAttribute("aria-selected") === "true");
    if (selectedTabs.length === 0) {
      tabs[0].setAttribute("aria-selected", "true");
      tabs[0].setAttribute("tabindex", "0");
    } else {
      selectedTabs.slice(1).forEach((t) => {
        t.setAttribute("aria-selected", "false");
        t.setAttribute("tabindex", "-1");
      });
    }

    // Click behavior
    tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        // Important: prevents odd editor/form behaviors
        e.preventDefault();
        e.stopPropagation();
        setSelectedTab(scope, e.currentTarget);
      });
    });

    // Keyboard navigation follows the ARIA tabs pattern.
    tabList.addEventListener("keydown", (e) => {
      const currentIndex = Math.max(0, tabs.indexOf(document.activeElement));
      let nextIndex = currentIndex;

      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (e.key === "Home") {
        nextIndex = 0;
      } else if (e.key === "End") {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      e.preventDefault();
      setSelectedTab(scope, tabs[nextIndex]);
      tabs[nextIndex].focus();
    });

    // Safety: if the currently selected panel is not visible, re-apply selection
    const initiallySelected = tabs.find((t) => t.getAttribute("aria-selected") === "true") || tabs[0];
    setSelectedTab(scope, initiallySelected);
  }

  function initAll(context) {
    const root = context || document;
    root.querySelectorAll(".tab-menu").forEach(initTabMenu);
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", () => initAll(document));
  window.addEventListener("load", () => initAll(document));

  // Theme editor support (important)
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:select", (e) => initAll(e.target));
  document.addEventListener("shopify:block:select", (e) => initAll(e.target));
})();